/* =========================================================
   MF Cart — assets/mf-cart.js
   Selection, bundle bar, event date, AJAX quantity/remove, saved-for-later checkout.
   Every price/discount/total shown comes from Shopify: after each change the section is
   re-rendered through the Section Rendering API (the `sections` parameter of the cart API).
   The only numbers added up here are the server-rendered line totals of SELECTED items,
   used for the estimate shown while some items are unselected.
   ========================================================= */
(function () {
  'use strict';

  var UNSEL_KEY = 'mf_cart_unsel';         // keys the shopper unticked (new items default to ticked)
  var SAVED_KEY = 'mf_saved_later';        // { items: [...], pending: bool }
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MOBILE = window.matchMedia('(max-width: 749px)');

  function $(r, s) { return r.querySelector(s); }
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function lsGet(k, d) { try { var v = JSON.parse(localStorage.getItem(k)); return v == null ? d : v; } catch (e) { return d; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); return true; } catch (e) { return false; } }
  function num(el, a) { return parseInt(el.getAttribute(a), 10) || 0; }
  function props(el) { try { return JSON.parse(el.getAttribute('data-props') || '{}') || {}; } catch (e) { return {}; } }
  function fingerprint(variant, p) {
    var keys = Object.keys(p || {}).sort();
    return String(variant) + '|' + keys.map(function (k) { return k + '=' + p[k]; }).join('&');
  }
  function iso(d) { var m = d.getMonth() + 1, day = d.getDate(); return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day; }
  function parseIso(s) { var p = String(s || '').split('-'); return p.length === 3 ? new Date(+p[0], +p[1] - 1, +p[2], 12) : null; }
  function pretty(s) { var d = parseIso(s); return d ? d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) : s; }
  function todayNoon() { var t = new Date(); t.setHours(12, 0, 0, 0); return t; }
  function daysUntil(s) { var d = parseIso(s); return d ? Math.round((d - todayNoon()) / 86400000) : null; }   // whole calendar days, local date

  function Cart(root) {
    var D = {};
    var fullTotal = '', fullSaved = '', fullSavedHidden = true;
    var busy = false;

    function readData() { try { D = JSON.parse($(root, '[data-mf-cart-data]').textContent); } catch (e) { D = {}; } }
    function money(cents) {
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: D.currency }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2) + ' ' + D.currency; }
    }
    function rows() { return $$(root, '[data-mf-line]'); }
    function unsel() { return lsGet(UNSEL_KEY, []); }
    function setUnsel(list) { lsSet(UNSEL_KEY, list); }
    function isSelected(row) { var cb = $(row, '[data-mf-line-check]'); return !!(cb && cb.checked && !cb.disabled); }
    function rowKeys(row) { return [row.getAttribute('data-key')].concat($$(row, '[data-mf-addon-line]').map(function (a) { return a.getAttribute('data-key'); })); }

    /* ---------- selection ---------- */
    function applySelection() {
      var off = unsel(), all = rows(), sel = 0, avail = 0;
      all.forEach(function (row) {
        var cb = $(row, '[data-mf-line-check]'); if (!cb) return;
        var ok = row.getAttribute('data-available') === 'true';
        cb.checked = ok && off.indexOf(row.getAttribute('data-key')) === -1;
        row.classList.toggle('is-unsel', !cb.checked);
        if (ok) avail++;
        if (cb.checked) sel++;
      });
      var sa = $(root, '[data-mf-select-all]');
      if (sa) {
        sa.checked = sel > 0 && sel === avail;
        sa.indeterminate = sel > 0 && sel < avail;
        sa.disabled = avail === 0;
      }
      updateBar(); updateSummary();
    }

    /* ---------- 1. bundle bar ---------- */
    function updateBar() {
      var bar = $(root, '[data-mf-bundle]'); if (!bar || !D.tiers) return;
      var count = 0;
      rows().forEach(function (row) { if (row.getAttribute('data-outfit') === 'true' && isSelected(row)) count += num(row, 'data-qty'); });
      var t1 = D.tiers[0], t2 = D.tiers[1];
      var tier = count >= t2.qty ? 2 : count >= t1.qty ? 1 : 0;
      var msg;
      if (tier === 2) msg = 'You\u2019ve unlocked ' + t2.pct + '% off \uD83C\uDF89';
      else if (tier === 1) { var m2 = t2.qty - count; msg = 'You\u2019ve unlocked ' + t1.pct + '% off! Add ' + m2 + ' more ' + (m2 === 1 ? 'outfit' : 'outfits') + ' for ' + t2.pct + '%'; }
      else { var m1 = t1.qty - count; msg = 'Add ' + m1 + ' more ' + (m1 === 1 ? 'outfit' : 'outfits') + ' to get ' + t1.pct + '% off'; }
      bar.setAttribute('data-tier', String(tier));
      $(bar, '[data-mf-bundle-msg]').textContent = msg;
      $(bar, '[data-mf-bundle-fill]').style.width = Math.min(100, count / t2.qty * 100) + '%';
      $$(bar, '[data-mf-mark]').forEach(function (m) { m.classList.toggle('is-done', +m.getAttribute('data-mf-mark') <= tier); });
      var admin = $(root, '[data-mf-admin-note]');
      if (admin) admin.hidden = !(tier > 0 && allSelected() && !D.hasAutoDiscount);
    }

    function allSelected() { return rows().every(function (r) { return isSelected(r); }); }

    /* ---------- floating bar: total + "You saved" ---------- */
    // All ticked: Shopify's cart total and savings exactly as rendered.
    // Some unticked: the sum of Shopify's own line totals for the ticked items (no discount maths).
    function updateSummary() {
      var barTotal = $(root, '[data-mf-bar-total]'), barSaved = $(root, '[data-mf-bar-saved]');
      var label = $(root, '[data-mf-checkout-label]'), btn = $(root, '[data-mf-checkout]'), hint = $(root, '[data-mf-checkout-hint]');
      if (!btn || !barTotal) return;
      var units = 0, fin = 0, cmp = 0, selRows = 0;
      rows().forEach(function (row) {
        if (!isSelected(row)) return;
        selRows++; units += num(row, 'data-qty');
        [row].concat($$(row, '[data-mf-addon-line]')).forEach(function (el) { fin += num(el, 'data-final'); cmp += num(el, 'data-compare'); });
      });
      if (allSelected()) {
        barTotal.textContent = fullTotal;
        if (barSaved) { barSaved.textContent = fullSaved; barSaved.hidden = fullSavedHidden; }
      } else {
        barTotal.textContent = money(fin);
        var saved = cmp - fin;
        if (barSaved) { barSaved.hidden = saved <= 0; barSaved.textContent = 'You saved ' + money(saved); }
      }
      label.textContent = 'Checkout (' + units + ')';
      btn.disabled = selRows === 0 || busy;
      if (hint) hint.hidden = selRows !== 0;
      document.body.classList.add('mf-cart-bar-on');
      var cbar = $(root, '[data-mf-cbar]');
      if (cbar) document.body.style.setProperty('--mf-cbar-h', cbar.offsetHeight + 'px');
    }

    /* ---------- 2. event date card ---------- */
    var editing = false;
    function evEls() {
      var box = $(root, '[data-mf-ev]');
      return box ? { box: box, input: $(box, '[data-mf-event-input]'), err: $(box, '[data-mf-event-err]'),
        cancel: $(box, '[data-mf-event-cancel]'), live: $(box, '[data-mf-ev-live]'), save: $(box, '[data-mf-event-save]') } : null;
    }
    function eventUI(value, announce) {
      var e = evEls(); if (!e) return;
      e.input.min = iso(todayNoon());
      var state = 'none', days = value ? daysUntil(value) : null;
      if (value && days != null && days >= 0 && !editing) state = days <= (D.eventSoonDays || 6) ? 'soon' : 'ok';
      if (editing) state = 'none';
      e.box.setAttribute('data-state', state);
      $$(e.box, '[data-mf-ev-date]').forEach(function (el) { el.textContent = value ? pretty(value) : ''; });
      var chip = days === 0 ? 'Today' : days === 1 ? '1 day to go' : days + ' days to go';
      $$(e.box, '[data-mf-ev-days]').forEach(function (el) { el.textContent = value && days != null && days >= 0 ? chip : ''; });
      e.input.value = value || '';
      if (state !== 'none' || !value) { e.err.hidden = true; e.input.removeAttribute('aria-invalid'); }   // clear stale errors
      e.save.textContent = editing ? 'Save date' : 'Add event date';
      e.cancel.hidden = !(editing && D.eventDate);
      if (announce && e.live) {
        e.live.textContent = state === 'ok' ? 'Event date saved: delivery before ' + pretty(value) + '.'
          : state === 'soon' ? 'Event date saved. Your event is very close, please contact us.'
          : value ? '' : 'Event date removed.';
      }
    }
    function saveEvent(value) {
      var prev = D.eventDate || '';
      editing = false;
      D.eventDate = value; eventUI(value, true);
      return fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Event date': value } })
      }).then(function (r) { if (!r.ok) throw 0; }).catch(function () {
        D.eventDate = prev; eventUI(prev);
        var e = evEls(); if (e) { e.err.textContent = 'Couldn\u2019t save the date. Please try again.'; e.err.hidden = false; }
      });
    }
    function submitEvent() {
      var e = evEls(); if (!e) return;
      var v = e.input.value;
      e.err.hidden = true;
      if (!v) {
        if (typeof e.input.showPicker === 'function') { try { e.input.showPicker(); return; } catch (x) {} }
        e.input.focus(); return;
      }
      if (v < iso(todayNoon())) { e.err.textContent = 'Please choose today or a later date.'; e.err.hidden = false; e.input.setAttribute('aria-invalid', 'true'); e.input.focus(); return; }
      saveEvent(v);
    }

    /* ---------- AJAX + re-render ---------- */
    function render(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-mf-cart]');
      if (!fresh) return;
      root.innerHTML = fresh.innerHTML;
      afterRender();
    }
    function refresh() {
      return fetch(D.cartUrl + '?section_id=' + encodeURIComponent(D.sectionId), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); }).then(render).catch(function () {});
    }
    function post(url, body) {
      body.sections = [D.sectionId];
      body.sections_url = D.cartUrl;
      return fetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok || j.status) { var e = new Error(j.description || j.message || 'Something went wrong. Please try again.'); e.status = r.status; throw e; }
          return j;
        });
      }).then(function (j) {
        if (j.sections && j.sections[D.sectionId]) render(j.sections[D.sectionId]); else return refresh();
      });
    }
    function rowBusy(row, on) { if (row) { row.classList.toggle('is-busy', on); $$(row, 'button, input').forEach(function (b) { if (on) b.setAttribute('data-was', b.disabled ? '1' : ''); b.disabled = on ? true : b.getAttribute('data-was') === '1'; }); } }
    function rowError(row, msg) { var e = row && $(row, '[data-mf-line-err]'); if (e) { e.textContent = msg; e.hidden = false; } }

    /* ---------- saved for later ---------- */
    function savedState() { return lsGet(SAVED_KEY, { items: [], pending: false }); }
    function renderSaved() {
      var box = $(root, '[data-mf-saved]'); if (!box) return;
      var st = savedState();
      if (!st.items.length || st.pending) { box.hidden = true; box.innerHTML = ''; return; }
      box.hidden = false;
      var h = '<h2 class="mf-saved__h">Saved for later (' + st.items.length + ')</h2><ul class="mf-saved__list" role="list">';
      st.items.forEach(function (it, i) {
        h += '<li class="mf-saved__item">' +
          (it.image ? '<img src="' + it.image + '" alt="" width="56" height="74" loading="lazy">' : '<span class="mf-saved__ph"></span>') +
          '<div class="mf-saved__txt"><p class="mf-saved__t"></p><p class="mf-saved__v"></p>' + (it.error ? '<p class="mf-saved__err"></p>' : '') + '</div>' +
          '<div class="mf-saved__acts"><button type="button" class="mf-saved__move" data-mf-saved-move="' + i + '">Move to cart</button>' +
          '<button type="button" class="mf-cart__link" data-mf-saved-del="' + i + '">Remove</button></div></li>';
      });
      box.innerHTML = h + '</ul>';
      $$(box, '.mf-saved__item').forEach(function (li, i) {
        var it = st.items[i];
        $(li, '.mf-saved__t').textContent = it.title + (it.quantity > 1 ? ' \u00d7 ' + it.quantity : '');
        $(li, '.mf-saved__v').textContent = it.vtitle || '';
        if (it.error) $(li, '.mf-saved__err').textContent = it.error;
      });
    }
    function addBack(it) {
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: it.variant_id, quantity: it.quantity, properties: it.properties || {} }] })
      }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok || j.status) throw new Error(j.description || 'This item is no longer available.'); }); });
    }
    // After checkout (or coming back from it) the unselected items return, still unticked.
    function restorePending() {
      var st = savedState();
      if (!st.pending || !st.items.length) { if (st.pending) { st.pending = false; lsSet(SAVED_KEY, st); } return Promise.resolve(false); }
      var keep = [], fps = [];
      return st.items.reduce(function (p, it) {
        return p.then(function () {
          return addBack(it).then(function () { fps.push(fingerprint(it.variant_id, it.properties)); })
            .catch(function (e) { it.error = e.message; keep.push(it); });
        });
      }, Promise.resolve()).then(function () {
        lsSet(SAVED_KEY, { items: keep, pending: false });
        lsSet('mf_cart_unsel_fps', fps);
        return true;
      });
    }
    function markRestoredUnselected() {
      var fps = lsGet('mf_cart_unsel_fps', []);
      if (!fps.length) return;
      var off = unsel();
      rows().forEach(function (row) {
        if (fps.indexOf(fingerprint(row.getAttribute('data-variant'), props(row))) > -1 && off.indexOf(row.getAttribute('data-key')) === -1) off.push(row.getAttribute('data-key'));
      });
      setUnsel(off); lsSet('mf_cart_unsel_fps', []);
    }

    /* ---------- 4. checkout with selected items only ---------- */
    function entryOf(el) {
      return { variant_id: num(el, 'data-variant'), quantity: num(el, 'data-qty'), properties: props(el),
        title: el.getAttribute('data-title') || '', vtitle: el.getAttribute('data-vtitle') || '', image: el.getAttribute('data-image') || '' };
    }
    function checkout() {
      var btn = $(root, '[data-mf-checkout]'), err = $(root, '[data-mf-checkout-err]');
      if (busy || !btn) return;
      var all = rows(), out = all.filter(function (r) { return !isSelected(r); });
      if (out.length === all.length) { $(root, '[data-mf-checkout-hint]').hidden = false; return; }
      busy = true; btn.disabled = true; btn.classList.add('is-loading'); if (err) err.hidden = true;
      if (!out.length) { window.location.href = D.checkoutUrl; return; }            // everything ticked: normal checkout
      var st = savedState(), moving = [], updates = {};
      out.forEach(function (row) {
        moving.push(entryOf(row)); updates[row.getAttribute('data-key')] = 0;
        $$(row, '[data-mf-addon-line]').forEach(function (a) { moving.push(entryOf(a)); updates[a.getAttribute('data-key')] = 0; });
      });
      var next = { items: st.items.concat(moving), pending: true };
      if (!lsSet(SAVED_KEY, next)) {                                                  // storage blocked: don't risk losing items
        busy = false; btn.disabled = false; btn.classList.remove('is-loading');
        err.textContent = 'Your browser blocked saving the unticked items. Remove them or tick all items to continue.'; err.hidden = false;
        return;
      }
      fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { if (!r.ok) throw 0; window.location.href = D.checkoutUrl; })
        .catch(function () {
          lsSet(SAVED_KEY, st);
          busy = false; btn.disabled = false; btn.classList.remove('is-loading');
          err.textContent = 'Couldn\u2019t prepare checkout. Please try again.'; err.hidden = false;
        });
    }

    /* ---------- events (delegated, survive re-renders) ---------- */
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-mf-line-check]')) {
        var key = t.closest('[data-mf-line]').getAttribute('data-key'), off = unsel().filter(function (k) { return k !== key; });
        if (!t.checked) off.push(key);
        setUnsel(off); applySelection();
      } else if (t.matches('[data-mf-select-all]')) {
        setUnsel(t.checked ? [] : rows().map(function (r) { return r.getAttribute('data-key'); }));
        applySelection();
      } else if (t.matches('[data-mf-event-input]')) {
        var ee = evEls(); if (ee) ee.err.hidden = true;
        if (t.value && t.value < iso(todayNoon())) { ee.err.textContent = 'Please choose today or a later date.'; ee.err.hidden = false; }
      }
    });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t || !root.contains(t)) return;
      var row = t.closest('[data-mf-line]');
      if (t.hasAttribute('data-mf-qty')) {
        var q = num(row, 'data-qty') + parseInt(t.getAttribute('data-mf-qty'), 10), max = row.getAttribute('data-max');
        if (q < 1) return;
        if (max !== '' && q > parseInt(max, 10)) { rowError(row, 'Only ' + max + ' available.'); return; }
        rowBusy(row, true);
        post('/cart/change.js', { id: row.getAttribute('data-key'), quantity: q })
          .catch(function (err) { rowBusy(row, false); rowError(row, err.message); });
      } else if (t.hasAttribute('data-mf-remove')) {
        var upd = {}; rowKeys(row).forEach(function (k) { upd[k] = 0; });
        rowBusy(row, true);
        post('/cart/update.js', { updates: upd }).catch(function (err) { rowBusy(row, false); rowError(row, err.message); });
      } else if (t.hasAttribute('data-mf-remove-key')) {
        rowBusy(row, true);
        post('/cart/change.js', { id: t.getAttribute('data-mf-remove-key'), quantity: 0 }).catch(function (err) { rowBusy(row, false); rowError(row, err.message); });
      } else if (t.hasAttribute('data-mf-remove-selected')) {
        var sel = rows().filter(isSelected);
        if (!sel.length) return;
        if (!window.confirm('Remove ' + sel.length + (sel.length === 1 ? ' item' : ' items') + ' from your cart?')) return;
        var u = {}; sel.forEach(function (r) { rowKeys(r).forEach(function (k) { u[k] = 0; }); rowBusy(r, true); });
        post('/cart/update.js', { updates: u }).catch(function () { refresh(); });
      } else if (t.hasAttribute('data-mf-event-remove')) {
        saveEvent('');
      } else if (t.hasAttribute('data-mf-event-save')) {
        submitEvent();
      } else if (t.hasAttribute('data-mf-event-edit')) {
        editing = true; eventUI(D.eventDate || '');
        var ed = evEls(); if (ed) ed.input.focus();
      } else if (t.hasAttribute('data-mf-event-cancel')) {
        editing = false; eventUI(D.eventDate || '');
      } else if (t.hasAttribute('data-mf-checkout')) {
        checkout();
      } else if (t.hasAttribute('data-mf-saved-move')) {
        var st = savedState(), i = +t.getAttribute('data-mf-saved-move'), it = st.items[i];
        if (!it) return;
        t.disabled = true; t.textContent = 'Moving\u2026';
        addBack(it).then(function () {
          st.items.splice(i, 1); lsSet(SAVED_KEY, st); return refresh();
        }).catch(function (err) { it.error = err.message; lsSet(SAVED_KEY, st); renderSaved(); });
      } else if (t.hasAttribute('data-mf-saved-del')) {
        var st2 = savedState(); st2.items.splice(+t.getAttribute('data-mf-saved-del'), 1); lsSet(SAVED_KEY, st2); renderSaved();
      }
    });

    function afterRender() {
      readData();
      var bt = $(root, '[data-mf-bar-total]'), bs = $(root, '[data-mf-bar-saved]');
      fullTotal = bt ? bt.textContent : ''; fullSaved = bs ? bs.textContent : ''; fullSavedHidden = bs ? bs.hidden : true;
      var keys = rows().map(function (r) { return r.getAttribute('data-key'); });
      markRestoredUnselected();
      setUnsel(unsel().filter(function (k) { return keys.indexOf(k) > -1; }));       // forget removed lines
      busy = false;
      applySelection();
      editing = false;
      eventUI(D.eventDate || '');
      renderSaved();
      if (!rows().length) document.body.classList.remove('mf-cart-bar-on');
    }

    readData();
    afterRender();
    restorePending().then(function (did) { if (did) refresh(); });

    // other tab / back button / coming back from checkout
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible' && !busy) refresh(); });
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      busy = false;
      restorePending().then(function () { refresh(); });
    });
    window.addEventListener('storage', function (e) { if (e.key === UNSEL_KEY) applySelection(); });
    window.addEventListener('resize', function () { var c = $(root, '[data-mf-cbar]'); if (c) document.body.style.setProperty('--mf-cbar-h', c.offsetHeight + 'px'); });
  }

  function init() { $$(document, '[data-mf-cart]').forEach(function (r) { if (!r.__mf) { r.__mf = true; Cart(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();